import { Container, Paper, Stack, Text, Title, Image } from '@mantine/core';
import { useProgramConfig } from '../hooks/useProgramConfig';

export default function NotFoundPage() {
  const { data: config } = useProgramConfig(false);
  const showLogo = config?.theme.showNotFoundLogo !== false;
  const logoUrl = config?.theme.notFoundLogoUrl ?? '/RIS_Rx_logo_digital_rgb_.png';

  return (
    <Container size="sm" py="xl" className="portal-page" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
      <Paper p="xl" radius="md" withBorder className="portal-panel" style={{ width: '100%' }}>
        <Stack align="center" gap="md">
          {showLogo && <Image src={logoUrl} alt="RIS Rx" maw={200} fit="contain" className="portal-header__logo" />}
          <Text className="portal-kicker">404</Text>
          <Title order={2} className="portal-section-title" ta="center">Page not found</Title>
          <Text size="sm" c="dimmed" ta="center">
            The page you requested does not exist or is not available for this program.
          </Text>
        </Stack>
      </Paper>
    </Container>
  );
}
